export default function setUIStateCookie(name, value) {
  return Cookies.set(name, value, {
    expires: 1
  });
};
